/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type CalendarOauthCallbackParams = {
state?: string | null;
code?: string | null;
error?: string | null;
};
